import React,{Component} from 'react';
import '../App.css';
import Login from '../comps/Login';
import {connect } from 'react-redux'
import Registration from '../comps/auth/Registration';

class HeaderBar extends Component{
    state = {
        seacrhInput: '',
        divWidth: null,
    }

    constructor(props){
        super(props);
        this.state = {
            showPopup: false,
            showPopup2: false,
        };
    }

    componentDidMount() {
        this.setState({
            divWidth: this.container.offsetWidth
        });
      }
    
    togglePopup() {
        this.setState({
            showPopup: !this.state.showPopup
        });
    }

    togglePopup2() {
        this.setState({
            showPopup2: !this.state.showPopup2
        });
    }

    render()
    {
        const { divWidth } = this.state;
        return(
            <div className='headerBar' ref={el => (this.container = el)}>
                {divWidth && this.renderHeader()}
            </div>
        )
    }

    renderHeader()
    {
        const { divWidth } = this.state;

        if (divWidth < 700)
        {
            return(
                <div style={{minWidth:"320px"}}>
                    <div>
                        {divWidth && this.renderUser()}
                    </div>
                </div>
            )
        }
        else
        {
            return(
                <div style={{minWidth:"600px"}}>
                    <div className="column">
                        {divWidth && this.renderUser()}
                    </div>
                    <div className="column">
                        <img onClick={() => this.gotoPage('/')} src='/images/Logo_AseanRead.png' style={this.styles.webLogo} />
                    </div>
                </div>
            )
        }
    }

    renderUser()
    {
        const { divWidth } = this.state;

        if (divWidth < 700)
        {
            if(this.props.logged != 0)
            {
                return(
                    <div>
                    <div className="headerLeft">
                        <div style={{padding:"10px 0px 10px 0px"}}>
                            Welcome, {this.props.logged.firstName}
                        </div>
                    </div>
                    <div className='headerRight'>
                        <button style={this.styles.logoutBtn} onClick={() => this.onClickLogout()}>Logout</button>
                    </div>
                    </div>

                )
            }
    
            else
            {
                return(
                    // <button onClick={() => this.gotoPage('/login/' + this.state.loginBtn)} style={this.styles.registerSty}>Login</button>
                    <div>
                    <div style={{float:'left', marginLeft:'4px'}}>
                        <img onClick={() => this.gotoPage('/')} src='/images/Logo_AseanRead.png' style={this.styles.webLogo} />

                    </div>
                    <div>
                                                <div className='headerRight'>
                        <button onClick={this.togglePopup.bind(this)} style={this.styles.registerSty}>Login</button>
                        {this.state.showPopup ?
                        <Login
                        closePopup={this.togglePopup.bind(this)}
                        />
                        : null
                        }
                    </div>
                    </div>
                    </div>

                    )
            }
        }
        else
        {
            if(this.props.logged != 0)
            {
                return(
                    <div className='headerRight'>
                        Welcome, {this.props.logged.firstName}{" "}
                        <button style={this.styles.logoutBtn} onClick={() => this.onClickLogout()}>Logout</button>
                    </div>
                )
            }
    
            else
            {
                return(
                    // <button onClick={() => this.gotoPage('/login/' + this.state.loginBtn)} style={this.styles.registerSty}>Login</button>
                    <div className='headerRight'>
                        <button onClick={this.togglePopup.bind(this)} style={this.styles.registerSty}>Login</button>
                        {this.state.showPopup ?
                        <Login
                        closePopup={this.togglePopup.bind(this)}
                        />
                        : null
                        }
                        <button onClick={this.togglePopup2.bind(this)} style={this.styles.registerSty}>Register</button>
                        {this.state.showPopup2 ?
                        <Registration
                        closePopup={this.togglePopup2.bind(this)}
                        />
                        : null
                        }
                    </div>
                    )
            }
        }
    }

    onClickLogout()
    {
        this.props.dispatch({ type: "SIGN_OUT" }) // how to pass action
        window.location.href = '/';
        localStorage.clear();
    }

    gotoPage = (pageLink) =>
    {
        if(pageLink == '/search/')
        {
            pageLink = '/search/allbooks'
        }

        this.props.history.push(pageLink)
    }

    updateSearchInput= (event) =>
    {
        this.setState({seacrhInput: event.target.value})
    }

    styles =
    {
        webLogo:{
            // fontSize: 30,
            // fontWeight: 700,
            // color: 'rgb(30, 123, 133)',
            // padding: '0 10px',
            cursor: 'pointer',
            height: '3.5em',
        },

        imageGap :{
            width: 35, 
            height: 35 , 
            marginLeft:20 , 
            marginRight:20,
            paddingTop: 5,
        },

        textName:
        {
            alignSelf:"center",
            fontSize:18,
            margin: 5, 
        },

        logoutBtn:{
            cursor: 'pointer',
            // borderRadius: '0 4px 4px 0',
            border: '1px solid grey',
            backgroundColor: '#f47141',
            color: 'white',
            borderRadius: '4px',
            width: "100px",
            height: "40px",
        },

        input:
        {
            fontSize: 15,
            height: '1.5em',
            width: 150,
            borderRadius: '4px 0px 0px 4px',
            border: '1px solid grey',
            padding: '1px 10px',
        },

        searchButton:
        {
            height: '100%',
            borderRadius: '0 4px 4px 0',
            border: '1px solid grey',
            backgroundColor: '#1e7b85',
        },

        registerSty:
        {
            cursor: 'pointer',
            margin: '0px 0px 0px 10px',
            // borderRadius: '0 4px 4px 0',
            border: '1px solid grey',
            backgroundColor: '#1e7b85',
            color: 'white',
            width: "100px",
            height: "40px",
            borderRadius: "4px"
        },

        // leftauto:{
        //     marginLeft: 'auto',
        //     marginRight: '10px',
        // },
    }
}

export default connect(state => state)(HeaderBar)